export const TIME = `h:mm a`
export const FULL_DATE = `MMMM do, yyyy`
export const FULL_DATE_AND_TIME = `MMMM do, yyyy 'at' h:mma`
